/**
 * @file paddle hub 详情 store
 * @author FengGuang(fengguang01@baidu.com)
 */
import { useEffect, useMemo, useState } from 'react';
import isNil from 'lodash/isNil';

import { fetchGetModelInfo } from '../../api/pages/paddleHubApi';
import { DEFAULT_PADDLE_MENU_FILTER } from '../../components/paddle-hub-menu/constants';
import { getSelectedMenuKey } from '../../components/paddle-hub-menu/paddleHubMenuHooks';
import {
    IPaddleHubDetailMarkdownInfoItem,
    IPaddleHubDetailModelDetail
} from './type';


// 解析页面参数
// 获取必要的url参数
const modelSelected = (init?: string[][] | Record<string, string> | string | URLSearchParams) => {
    const urlSearch = new URLSearchParams(init);
    const resSearch = new URLSearchParams();

    const setParam = (params: URLSearchParams, key: string, value?: string | null) => {
        !isNil(value) ? params.set(key, value) : params.delete(key);
    };

    setParam(resSearch, 'name', urlSearch.get('name'));
    setParam(resSearch, 'en_category', urlSearch.get('en_category'));
    resSearch.sort();
    return resSearch.toString();
};



export function useModelDetail() {
    const modelDetailState = useState<IPaddleHubDetailModelDetail>({
        name: '',
        summary: '',
        category: '',
        dataset: '',
        network: '',
        type: '',
        typeName: '',
        info: []
    });
    const setModelDetail = modelDetailState[1];

    useEffect(() => {
        (async (): Promise<void> => {
            const fetchFunc = fetchGetModelInfo(modelSelected(window.location.search.slice(1)));

            let res = await fetchFunc.catch();
            if (res) {
                const theData: any = res.body.result.data || {};
                const info: IPaddleHubDetailMarkdownInfoItem[]
                    = (theData.info as any[]).map(item => {
                        return {
                            detail: item.detail,
                            hot: item.hot,
                            md5: item.md5,
                            raw_name: item.raw_name,
                            type: item.type,
                            url: item.url,
                            version: item.version
                        };
                    });

                const theCategory = (theData.category || []) as any[];
                const type = theCategory
                    .map(item => item.chn)
                    .join(' - ');
                const typeName = theCategory.slice(-1)[0].en || '';

                setModelDetail({
                    name: theData.name,
                    summary: theData.summary,
                    category: theData.category,
                    dataset: theData.dataset,
                    network: theData.network,
                    type,
                    typeName,
                    info
                });
            }
        })();
    }, [setModelDetail]);

    return modelDetailState;
}

export default function usePaddleHubDetailHooks() {
    const [modelDetail] = useModelDetail();

    const selectedMenuKey = useMemo(() => {
        return getSelectedMenuKey({
            filter: DEFAULT_PADDLE_MENU_FILTER,
            value: modelDetail.typeName
        });
    }, [modelDetail.typeName]);

    const backToHubBreadcrumbUrl = useMemo(() => {
        return selectedMenuKey ? `/hubsearch?${selectedMenuKey}` : '';
    }, [selectedMenuKey]);


    return {
        modelDetail,
        backToHubBreadcrumbUrl
    };
};
